/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable object-shorthand */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import type { ChangeEventHandler } from "react";
import { useState, useRef, useEffect } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import {
  Button,
  Card,
  CardContent,
  Input,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@repo/ui";
import { PencilIcon } from "lucide-react";
import { Link } from "react-router-dom";
import {
  useDeleteRoute,
  useGenerateRoster,
  useGetAllRoutes,
  useUpdateRoutesTeam,
} from "utils/apis/rotes.api";
// eslint-disable-next-line import/no-cycle
import { showToast } from "utils/helper";
import { useUser } from "hooks/use-user";
import { fixKendoGridContent } from "pages/tickets/utils";
import AddRoute from "./add-route";
import EditRoute from "./edit-route";

export default function RoutesManagement() {
  const initialDataState = {
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  };

  const currentDate = new Date();

  const DATA_ITEM_KEY = "routeId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);
  const user = useUser() as any;
  const CashCenterId = user.CashCenterId;

  const [selectedState, setSelectedState] = useState<any>({});
  const [dataState, setDataState] = useState<any>(initialDataState);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedRoutes, setSelectedRoutes] = useState([]);

  const [operationDate, setOperationDate] = useState(currentDate);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [btnRosterDisabled, setBtnRosterDisabled] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [btnRosterText, setBtnRosterText] = useState("Generate Roster");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [btnDeleteRouteDisabled, setBtnDeleteRouteDisabled] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [btnDeleteRouteTxt, setBtnDeleteRouteTxt] = useState(
    "Remove Routes From Roster"
  );

  const [refresh, setRefresh] = useState(false);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [showAddModel, setShowAddModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [route, setRoute] = useState(null);

  const [routesTeams, setRoutesTeams] = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [btnUpdateRTTxt, setBtnUpdateRTTxt] = useState("Update Field Teams");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const pageSize = 25;

  const routesTeamsList = useRef<any[]>([]);
  const { data: routes } = useGetAllRoutes({
    pageNumber: currentPage,
    pageRowCount: pageSize,
    searchCriteria: filter,
    operationDate: operationDate,
    cashCenterId: CashCenterId,
  });

  const {
    mutate: updateRoutesTeam,
    isSuccess: updateRouteTeamSuccess,
    isError: updateRouteTeamError,
    data: updateRouteTeamRes,
    isPending: updateRouteTeamPending,
  } = useUpdateRoutesTeam();
  const { isSuccess: generateRosterSuccess, isError: generateRosterError } =
    useGenerateRoster();

  const { isSuccess: deleteRouteSuccess, isError: deleteRouteError } =
    useDeleteRoute();

  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  const onFilterChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setFilter(event.target.value);
  };

  const toggleAddModel = () => {
    setShowAddModel(!showAddModel);
  };

  const toggleEditModel = () => {
    setShowEditModel(!showEditModel);
  };

  function EditButtonCell({ dataItem }: any) {
    const onClick = () => {
      setRoute(dataItem);
      toggleEditModel();
    };

    return (
      <td className="text-center mt-3">
        <Button className="w-full" onClick={onClick}>
          <PencilIcon />
        </Button>
      </td>
    );
  }

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File;
    if (!fileObj) return;
    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "csv",
      ].includes(fileObj.type)
    )
      return showToast("error", "File formate not supported.");
    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;

        for (let index = 1; index < rows.length; index++) {
          const routeNo = rows[index][0];
          const teamLeader = rows[index][1];
          const driver = rows[index][2];
          const guard1 = rows[index][3] || "";
          const guard2 = rows[index][4] || "";
          const guard3 = rows[index][5] || "";

          if (guard1) {
            const obj = {
              routeNo,
              teamLeader,
              driver,
              guard1,
              guard2,
              guard3,
            };

            routesTeamsList.current.push(obj);
          }
        }

        if (routesTeamsList.current.length > 0) {
          const locList: any = [];
          routesTeamsList.current.forEach((sl) => {
            locList.push(sl);
          });

          setRoutesTeams(locList);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const onBtnUpdateRoutesTeams = () => {
    if (routesTeams.length === 0) {
      showToast("error", "No routes added.");
      return;
    }

    const teams = routesTeams?.map((rt: any) => ({
      routeNo: rt.routeNo,
      teamLeader: rt.teamLeader.toString(),
      driver: rt.driver.toString(),
      guard1: rt.guard1.toString(),
      guard2: rt.guard2 ? rt.guard2.toString() : "",
      guard3: rt.guard3 ? rt.guard3.toString() : "",
    }));

    setBtnUpdateRTTxt("Updating Teams....");

    updateRoutesTeam(teams);
  };

  // const onBtnGenerateRosterClicked = () => {
  //   const rosterDto = {
  //     cashCenterId: CashCenterId,
  //     operationDate,
  //     routes: selectedRoutes,
  //   };

  //   setBtnRosterDisabled(true);
  //   setBtnRosterText("Generating Roster...");

  //   generateRoster(rosterDto);
  // };

  useEffect(() => {
    if (updateRouteTeamSuccess) {
      setRoutesTeams([]);
      setOpenFileUpload(false);
      routesTeamsList.current = [];
      const error = updateRouteTeamRes?.data;
      if (error) {
        setErrorMessage(error);
        setRefresh(!refresh);
      } else {
        setErrorMessage("");
      }
      setBtnUpdateRTTxt("Update Field Teams");
    }
    if (updateRouteTeamError) {
      setBtnUpdateRTTxt("Update Field Teams");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRouteTeamSuccess, updateRouteTeamError]);

  useEffect(() => {
    if (generateRosterSuccess) {
      setOperationDate(currentDate);
      setBtnRosterText("Generate Roster");
    }
    if (generateRosterError) {
      setBtnRosterDisabled(false);
      setBtnRosterText("Generate Roster");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateRosterSuccess, generateRosterError]);

  const onOperationsDateChanged = (event: any) => {
    if (event.target.value) {
      const value = event.target.value;
      setOperationDate(value);
    }
  };

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState)?.map((key) => ({
      routeId: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRoutes = selections.filter((req) => req.isSelected === true);

    const routesIds: any = selectedRoutes?.map((rt) => ({
      routeId: rt.routeId,
    }));

    setSelectedRoutes(routesIds);

    if (routesIds.length > 0) {
      setBtnRosterDisabled(false);
      setBtnDeleteRouteDisabled(false);
    } else {
      setBtnRosterDisabled(true);
      setBtnDeleteRouteDisabled(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState)?.map((key) => ({
      routeId: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRoutes = selections.filter((req) => req.isSelected === true);

    const routesIds = selectedRoutes?.map((rt) => ({
      routeId: rt.routeId,
    }));

    if (routesIds.length > 0) {
      setBtnRosterDisabled(false);
      setBtnDeleteRouteDisabled(false);
    } else {
      setBtnRosterDisabled(true);
      setBtnDeleteRouteDisabled(true);
    }
  };

  // const onBtnDeleteRoutesFromRosterClicked = () => {
  //   const rosterDto = {
  //     cashCenterId: CashCenterId,
  //     operationDate,
  //     routes: selectedRoutes,
  //   };

  //   setBtnDeleteRouteDisabled(true);
  //   setBtnDeleteRouteTxt("Deleting Routes from Roster...");
  //   deleteRoute(rosterDto);
  // };

  useEffect(() => {
    if (deleteRouteSuccess) {
      setBtnDeleteRouteTxt("Delete Routes from Roster");
      setBtnDeleteRouteDisabled(true);
      setSelectedRoutes([]);
      setRefresh(true);
    }

    if (deleteRouteError) {
      setBtnDeleteRouteTxt("Delete Routes from Roster");
    }
  }, [deleteRouteSuccess, deleteRouteError]);

  return (
    <>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Routes Management</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="flex mx-4 flex-col mt-2 gap-4">
        <CardContent className="pt-6">
          <div className="flex gap-2 mt-3">
            {/* <Button
              disabled={btnRosterDisabled}
              variant="secondary"
              onClick={onBtnGenerateRosterClicked}
            >
              {btnRosterText}
            </Button> */}
            {/* <Button
              disabled={btnAddRouteRosDisabled}
              onClick={onBtnAddRoutesToRosterClicked}
              variant="secondary"
            >
              {btnAddRouteTxt}
            </Button> */}
            {/* <Button
              disabled={btnDeleteRouteDisabled}
              onClick={onBtnDeleteRoutesFromRosterClicked}
              variant="secondary"
            >
              {btnDeleteRouteTxt}
            </Button> */}
            {/* <Button
              variant="secondary"
              className="w-50 gap-3"
              onClick={() => {
                setOpenFileUpload(true);
              }}
            >
              <FaCloudUploadAlt /> {btnUpdateRTTxt}
            </Button> */}
            <Button variant="secondary" onClick={toggleAddModel}>
              Add New Route
            </Button>
            <DatePicker
              min={currentDate}
              className="w-[220px] ml-auto"
              value={operationDate}
              onChange={onOperationsDateChanged}
            />
            <Input
              className="w-[220px]"
              value={filter}
              onChange={onFilterChange}
              placeholder="Search"
            />
          </div>
          <div className="flex mt-3">
            <div className="flex-1" />
            <div className="flex-1">
              {errorMessage ? (
                <div>
                  <label className="h5 text-error w-100">
                    Routes' team not updated, please check validations
                  </label>
                  <br />
                  <br />
                  <label className="h5 text-error w-100">{errorMessage}</label>
                </div>
              ) : null}
            </div>
          </div>
          <div className="border-b mt-3 mb-3 bg-accent" />
          <Grid
            sortable
            filterable
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            selectable={{
              enabled: true,
              drag: false,
              cell: false,
              mode: "multiple",
            }}
            data={process(
              routes?.data?.map((req: any) => ({
                ...req,
                [SELECTED_FIELD]: selectedState[idGetter(req)],
              })) || [],
              dataState
            )}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            pageable
            total={routes?.totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <Column
              field={SELECTED_FIELD}
              filterable={false}
              width="50px"
              headerSelectionValue={
                routes?.data?.findIndex(
                  (item: any) => !selectedState[idGetter(item)]
                ) === -1
              }
              className="text-center"
            />
            <Column field="cashCenter" title="Cash Center" width={150} />
            <Column field="office" title="Office" width={300} />
            <Column
              field="routeNo"
              title="Route No"
              width={180}
              className="text-center"
            />
            <Column
              field="description"
              title="Description"
              // width={150}
              // className="text-center"
            />
            <Column
              field="routeArea"
              title="Area"
              width={120}
              className="text-center"
            />
            {/* <Column
              field="priority"
              title="Priority"
              width={80}
              className="text-center"
            />
            <Column
              field="requiredTeamMembers"
              title="Team"
              width={80}
              className="text-center"
            />
            <Column
              field="teamNationalityCount"
              title="Co-nationals"
              className="text-center"
              width={120}
            />
            <Column
              field="routeStartTime"
              title="Start Time"
              format="{0:HH:mm}"
              width={120}
              className="text-center"
            />
            <Column
              field="routeEndTime"
              title="End Time"
              format="{0:HH:mm}"
              width={120}
              className="text-center"
            />
            <Column width={400} field="teamInfo" title="Current Field Team" /> */}
            <Column
              width="80"
              title="Edit"
              className="text-center"
              filterable={false}
              cell={EditButtonCell}
            />
          </Grid>
        </CardContent>
      </Card>
      <Dialog
        open={openFileUpload}
        onOpenChange={(open) => {
          setOpenFileUpload(open);
          setRoutesTeams([]);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Field Teams</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {routesTeams?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now update field team
                </p>
                <Button
                  disabled={updateRouteTeamPending}
                  isLoading={updateRouteTeamPending}
                  variant="secondary"
                  onClick={onBtnUpdateRoutesTeams}
                >
                  Update Filed Team
                </Button>
              </div>
            ) : (
              <div className="flex items-center justify-center w-full">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      XLS, XLSX, CSV (MAX. 5GB)
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler}
                  />
                </label>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <Dialog open={showAddModel} onOpenChange={toggleAddModel}>
        <DialogContent className="max-w-[950px]">
          <DialogHeader>
            <DialogTitle>Add New Route</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            <AddRoute onAddRoute={toggleAddModel} />
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <Dialog open={showEditModel} onOpenChange={toggleEditModel}>
        <DialogContent className="max-w-[950px]">
          <DialogHeader>
            <DialogTitle>Edit Route</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {route ? (
              <EditRoute route={route} onRouteUpdated={toggleEditModel} />
            ) : null}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </>
  );
}
